import UtilityHelper from "../utilities/UtilityHelper";

export const getFontFamily = (fontName: string): string => {
  let classes: Array<string> = [];
  if (UtilityHelper.isNotEmpty(fontName)) {
    fontName = fontName.toLowerCase();

    let ff: string = "book";
    if (fontName === "light") {
      ff = "light";
    } else if (fontName === "book") {
      ff = "book";
    } else if (fontName === "medium") {
      ff = "medium";
    } else if (fontName === "bold") {
      ff = "bold";
    }
    classes.push(`font-gotham-${ff}`);
  }

  return classes.join(" ");
};

export const getFontSize = (fontSize: string): string => {
  let classes: Array<string> = [];
  if (UtilityHelper.isNotEmpty(fontSize)) {
    classes.push(`font-size-${fontSize.trim()}`);
  }

  return classes.join(" ");
};

export const getTextColor = (textColor: string): string => {
  let classes: Array<string> = [];
  if (UtilityHelper.isNotEmpty(textColor)) {
    classes.push(`color-${textColor.trim()}`);
  }

  return classes.join(" ");
};

export const textCase = (text: string): string => {
  if (UtilityHelper.isNotEmpty(text)) {
    text = text.toLowerCase();
  }
  return text;
};
